/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Submitbutton_Label1Inputs */

const ja_contact_submitbutton_label1 = /** @type {(inputs: Contact_Submitbutton_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信する`)
};

const en_contact_submitbutton_label1 = /** @type {(inputs: Contact_Submitbutton_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send!`)
};

/**
* | output |
* | --- |
* | "Send!" |
*
* @param {Contact_Submitbutton_Label1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_submitbutton_label1 = /** @type {((inputs?: Contact_Submitbutton_Label1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Submitbutton_Label1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_submitbutton_label1(inputs)
	return en_contact_submitbutton_label1(inputs)
});
export { contact_submitbutton_label1 as "contact_submitButton_label" }